export default function iFrameModal(element, attribute) {
  let modalAttr = document.querySelectorAll(element)
  modalAttr.forEach(function (el) {
    const id = el.getAttribute(attribute);
    const modal = document.querySelector(id);

    if (modal == null) {
      return;
    }

    el.addEventListener('click', function () {
      const value = this.getAttribute(attribute);
      const iframe = document.querySelector(value).querySelector('iframe');

      if (iframe) {
        let iframeSrc = document.querySelector(value).querySelector('iframe').getAttribute('src');
        iframeSrc = `${iframeSrc}?autoplay=1`;
        iframe.setAttribute('src', iframeSrc);
      }
    });

    modal.addEventListener('hidden.bs.modal', function (event) {
      const iframe = this.querySelector('iframe').getAttribute('src').replace('?autoplay=1', '');
      this.querySelector('iframe').setAttribute('src', iframe)
    })
  })
}

